import { LupaIcon } from "assets/icons/LupaIcon";
import { showErrorToast } from "components/CustomAlerts/CustomToast";
import { Input } from "components/Input/Input";
import { Pagination } from "components/Pagination/Pagination";
import { Select } from "components/Select/Select";
import { DEFAULT_LIMIT_PAGINATION } from "constants/appConstants";
import { useFormik } from "formik";
import { UsuarioI } from "interfaces/Usuario";
import { useEffect, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getUsuarios } from "services/usuarios";
import { fetchRoles } from "store/slices/appSlice";
import { AppDispatch, RootState } from "store/store";
import { UsuariosABM } from "./UsuariosABM/UsuariosABM";
import { UsuariosRowActions } from "./UsuariosTable/UsuariosRowActions";
import { UsuariosTable } from "./UsuariosTable/UsuariosTable";

export const Usuarios = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [elementos, setElementos] = useState<UsuarioI[]>([]);
  const [cantidad, setCantidad] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>();

  const [actionType, setActionType] = useState<"create" | "edit" | undefined>();
  const [selectedElement, setSelectedElement] = useState<
    UsuarioI | undefined
  >();

  const [showModalABM, setShowModalABM] = useState(false);

  const initialValues = {
    roles: "",
    email: "",
  };

  const { values, handleChange, resetForm } = useFormik({
    initialValues,
    onSubmit: () => {},
  });

  const dispatch: AppDispatch = useDispatch();
  const { roles, loadingAppData } = useSelector((st: RootState) => st.appData);

  const searchUsuarios = async (params?: {
    filtros?: { [key: string]: any };
  }) => {
    try {
      setIsLoading(true);
      const response = await getUsuarios({ ...params?.filtros });
      setElementos(response.elementos);
      setCantidad(response.cantidad);
      setPage(response.page);
      setLimit(params?.filtros?.limit ?? DEFAULT_LIMIT_PAGINATION);
    } catch (err) {
      showErrorToast("Error al buscar usuarios");
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangePagination = (newFiltros: {
    [key: string]: string | number;
  }) => {
    searchUsuarios({ filtros: { ...values, ...newFiltros } });
  };

  const refreshTable = () => {
    setPage(1);
    searchUsuarios({ filtros: { ...values, page: 1 } });
  };

  const handleClearFilters = () => {
    resetForm();
    searchUsuarios();
  };

  const handleEdit = (elemento: UsuarioI) => {
    setActionType("edit");
    setSelectedElement(elemento);
    setShowModalABM(true);
  };

  const handleCreate = () => {
    setActionType("create");
    setShowModalABM(true);
  };

  const handleCloseModal = () => {
    setShowModalABM(false);
    setTimeout(() => setActionType(undefined), 500);
  };

  const renderActions = (elemento: UsuarioI) => {
    return (
      <UsuariosRowActions
        elemento={elemento}
        onClickEdit={handleEdit}
        refreshTable={refreshTable}
      />
    );
  };

  const handleChangeWithResetPage = (pageOne: any) => {
    setPage(1);
    handleChange(pageOne);
  };

  useEffect(() => {
    searchUsuarios({ filtros: { ...values, limit, page } });
  }, [values]);

  useEffect(() => {
    if (!roles) dispatch(fetchRoles());
  }, []);

  return (
    <section>
      <h1 className="section-title" onClick={() => console.log({ limit })}>
        Gestión de usuarios
      </h1>
      <h2 className="section-subtitle mt-2">
        Buscá y agregá usuarios gestionar la plataforma.
      </h2>
      <div className="d-flex justify-content-between mt-4 mb-3">
        <div className="d-flex column-gap-3">
          <Input
            size="sm"
            id="email"
            onChange={handleChangeWithResetPage}
            placeholder="Buscar usuario"
            values={values}
            startIcon={<LupaIcon />}
          />
          <Select
            id="rol_id"
            optionsFormatConfig={{ value: "id", label: "nombre" }}
            options={roles ?? []}
            onChange={handleChangeWithResetPage}
            isLoading={loadingAppData.roles}
            placeholder="Rol"
            width="150px"
            values={values}
          />
          <Button
            size="sm"
            variant="secondary"
            className="clear-filters-button"
            onClick={handleClearFilters}
          >
            Limpiar filtros
          </Button>
        </div>

        <Button size="lg" onClick={handleCreate}>
          Nuevo usuario
        </Button>
        <UsuariosABM
          showModal={showModalABM}
          actionType={actionType}
          onClose={handleCloseModal}
          elemento={selectedElement}
          refreshTable={refreshTable}
        />
      </div>

      {isLoading && (
        <div className="d-flex justify-content-center w-full">
          <Spinner />
        </div>
      )}

      {!isLoading && elementos && cantidad != undefined && (
        <>
          <UsuariosTable elementos={elementos} renderActions={renderActions} />
          <Pagination
            totalItems={cantidad}
            currentPage={page}
            currentLimit={limit}
            onChangePage={handleChangePagination}
            showPaginationOnlyOnMoreThanPages={1}
          />
        </>
      )}
    </section>
  );
};
